/**
 * API client for the tanks endpoint.
 */
import { buildApiUrl } from './config';
import { apiClient } from './client';
import type { Tank } from '../types/tank';

export async function getTanks(): Promise<Tank[]> {
  const response = await apiClient(buildApiUrl('/api/tanks'), { method: 'GET' });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: response.statusText }));
    throw new Error(error.detail || `HTTP ${response.status}: ${response.statusText}`);
  }

  const data = await response.json();
  return data.tanks;
}

/** React Query key for the tanks list. */
export const tanksQueryKey = ['tanks'];
